<template>
    <div id="hinweise">
        <!-- Name der Klasse -->
        <p class="name" v-if="klasse.selectionType == 'class'">
            Die Objekte, die ich programmieren möchte, sind vom Typ <strong>{{ klasse.name ? klasse.name : ' ... '
            }}</strong>.
        </p>
        <!-- Attribute -->
        <p class="attribut" v-else-if="klasse.selectionType == 'field'">
            {{ uart }} {{klasse.name}} hat als Attribut (also als eine Eigenschaft oder einen Bestandteil)
            <strong>{{ klasse.selected.name ? klasse.selected.name : '...' }}</strong>
            vom Typ <strong>{{ klasse.selected.type ? klasse.selected.type : '... ' }}</strong>.
        </p>
        <!-- Methode -->
        <div v-else-if="klasse.selectionType == 'method'">
            <div v-if="klasse.selected.name != klasse.name || klasse.selected.name == ''" class="name">
                <!-- normale Methode oder leerer Eintrag -->
                {{ uart }} {{klasse.name ? klasse.name : ' ... ' }} besitzt die Methode (also die Fähigkeit)
                <strong>{{ klasse.selected.name ? klasse.selected.name : '... ' }}</strong>.
            </div>
            <div v-else class="name"> <!-- Konstruktor -->
                Ein Konstruktor der Klasse.
            </div>
            <div class="parameter" v-if="klasse.selected.name != ''">
                <template v-if="klasse.selected.name == klasse.name">
                    <div v-if="klasse.selected.parameters.length == 0">
                        Damit der Konstruktor ausgeführt kann, benötigt er keine Parameter.
                    </div>
                    <div v-else>
                        Damit der Konstruktor ausgeführt kann, benötigt er folgende Parameter:
                    </div>
                </template>
                <template v-else>
                    <div v-if="klasse.selected.parameters.length == 0">
                        Damit {{ uart.toLowerCase()
                        }} {{klasse.name}} die Methode <strong>{{klasse.selected.name}}</strong>
                        ausführen kann, benötigt {{ pronomen }} keine Parameter.
                    </div>
                    <div v-else>
                        Damit {{ uart.toLowerCase()
                        }} {{klasse.name}} die Methode <strong>{{klasse.selected.name}}</strong>
                        ausführen kann, benötigt {{ pronomen }} folgende Parameter:
                    </div>
                </template>
                <div class="parameterliste" v-for="v in klasse.selected.parameters">
                    <strong>{{ v.name }}</strong> vom Typ <strong>{{ v.type }}</strong>
                </div>
            </div>
            <div v-if="klasse.selected.returnType != ''" class="rueckgabetyp">
                <span v-if="klasse.selected.returnType =='void'">
                    Nach der Ausführung der Methode, gibt diese nichts zurück.
                </span>
                <span v-else-if="klasse.selected.returnType =='int'">
                    Nach der Ausführung der Methode, gibt diese eine <strong>ganze Zahl</strong> zurück.
                </span>
                <span v-else-if="klasse.selected.returnType =='double'">
                    Nach der Ausführung der Methode, gibt diese eine <strong>Kommazahl</strong> zurück.
                </span>
                <span v-else-if="klasse.selected.returnType =='String'">
                    Nach der Ausführung der Methode, gibt diese eine <strong>Zeichenkette</strong> zurück.
                </span>
                <span v-else-if="klasse.selected.returnType =='boolean'">
                    Nach der Ausführung der Methode, gibt diese einen <strong>Wahrheitwert</strong> (<code>true</code> oder <code>false</code>) zurück.
                </span>
                <span v-else>
                    Nach der Ausführung der Methode, gibt diese etwas vom Typ
                    <strong>{{ klasse.selected.returnType }}</strong> als Antwort zurück.
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'hinweise',
        props: ['klasse'],
        computed: {
            // unbestimmter Artikel
            uart() {
                let g = this.klasse.geschlecht;
                if (g == 'm' || g == 'n')
                    return 'Ein';
                else if (g == 'w')
                    return 'Eine';
                else
                    return 'Ein/e';
            },
            pronomen() {
                let g = this.klasse.geschlecht;
                if (g == 'm')
                    return 'er';
                else if (g == 'w')
                    return 'sie';
                else if (g == 'n')
                    return 'es';
                else
                    return 'er/sie/es';
            }
        }
    }
</script>

<style scoped="">
    #hinweise {
        width: 100%;
    }
    .name, .parameter, .rueckgabetyp, .attribut {
        line-height: 110%;
        margin-top: 0px;
        margin-bottom: 5px;
        padding: 10px;
        background-color: gainsboro;
    }

    .parameterliste {
        padding-left: 40px;
        margin: 0px;
    }
</style>



// WEBPACK FOOTER //
// Hinweise.vue?3d549819